export default "__VITE_ASSET__CKPwU6k6__"